import { WindowHelper } from '../WindowHelper';

export default class WorkListRestoreLinks {
    getEvent() {
        return this.event;
    }

    getTriggerNodes() {
        return this.triggerNodes;
    }

    getAllATagWithin(node) {
        if (node.querySelector('a')) {
            return node.querySelectorAll('a');
        }
        return null;
    }

    getHref(node) {
        return node.getAttribute('href');
    }

    resetLinks(node) {
        const nestedATags = this.getAllATagWithin(node);

        if (nestedATags != null) {
            const nodeHref = this.getHref(nestedATags[0]);

            for (let i = 0; i < nestedATags.length; i++) {
                nestedATags[i].addEventListener('click', () => {
                    window.location.href = nodeHref;
                }, true);
            }
        }
    }

    constructor() {
        this.event = WindowHelper.isTouchDevice() ? 'touchend' : 'click';

        if (WindowHelper.isElementThere('.work-list-container')) {
            this.triggerNodes = document.querySelectorAll('.work-list-item');
        }
    }
}
